import { HambergerMenu, LogoutCurve, Profile2User, User } from "iconsax-react";
import { useState, useRef, useEffect } from "react";
import Button from "./Button";
import axios from "axios";
import { LOGOUT_API } from "../Constant/api";
import { useNavigate } from "react-router-dom";
import { useToast } from "./Toast";
import { EVENT_LIST, LOW_END_EVENT_LIST, USER_LIST } from "../Router/path";
import { LoadingOverlay } from "./LoadingOverlay";
import Can from "./Can";

const Header = ({ noSidebar = false, toggleSidebar, doNotLink = false }) => {
  const [loading, setLoading] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);
  // Close profile menu on outside click
  useEffect(() => {
    if (!showProfileMenu) return;
    const handleClickOutside = (event) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showProfileMenu]);

  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogout = () => {
    setLoading(true);
    setShowProfileMenu((prev) => !prev);
    axios.post(LOGOUT_API).then((response) => {
      if (response.data.success) {
        sessionStorage.removeItem("bearer_token");
        sessionStorage.removeItem("event_id");
        sessionStorage.removeItem("dietary");
        sessionStorage.removeItem("seat");
        navigate("/");
        toast("Logout Success", "success");
      } else {
        toast(response.data.message, "error");
      }
      setLoading(false);
    });
  };

  return (
    <div className="flex sticky top-0 z-10 w-full min-h-[80px] max-h-[80px] items-center justify-between bg-white px-[16px] md:px-[32px] border-b border-[#EFF0F2]">
      {loading && <LoadingOverlay />}
      <div className="flex w-full items-center justify-start gap-[16px]">
        {!noSidebar && (
          <Button variant="icon" onClick={toggleSidebar}>
            <HambergerMenu size="14" />
          </Button>
        )}
        <img
          src="/images/logo-w-brand.svg"
          className="w-[118px] h-[32px] hover:cursor-pointer"
          alt="logo"
          onClick={() => {
            if (doNotLink) return;
            sessionStorage.removeItem("event_id");
            sessionStorage.removeItem("dietary");
            sessionStorage.removeItem("seat");
            if (
              sessionStorage
                .getItem("permissions")
                ?.includes("low_end_event_view") &&
              sessionStorage.getItem("permissions")?.length === 1
            ) {
              navigate(LOW_END_EVENT_LIST);
            } else {
              navigate(EVENT_LIST);
            }
          }}
        />
      </div>
      <div className="flex w-full items-center justify-end">
        {/* <div className="">
          <Button onClick={handleLogout} disabled={loading}>
            <LogoutCurve size="16" />
            Logout
          </Button>
        </div> */}
        <div className="relative w-fit h-fit" ref={profileMenuRef}>
          <div
            className="rounded-full border border-[#4F5665] overflow-hidden p-[2px] cursor-pointer"
            onClick={() => setShowProfileMenu((prev) => !prev)}
          >
            <User size="28" color="#4F5665" />
          </div>

          {showProfileMenu && (
            <div className="absolute top-14 right-0 bg-white border border-[#EFF0F2] p-2 w-[250px] rounded-lg flex flex-col gap-2">
              <Can permission="view_user">
                <Button
                  onClick={() => {
                    setShowProfileMenu(false);
                    navigate(USER_LIST);
                  }}
                  disabled={loading}
                  variant="custom"
                  className="w-full h-fit hover:bg-[#E5E5E5]"
                >
                  <Profile2User size="16" />
                  User Management
                </Button>
              </Can>
              <Button
                onClick={handleLogout}
                disabled={loading}
                variant="custom"
                className="w-full text-red-500 hover:bg-[#E5E5E5]"
              >
                <LogoutCurve size="16" />
                Logout
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
